import { render, staticRenderFns } from "./MTag.vue?vue&type=template&id=b90bdeea&scoped=true&"
var script = {}
import style0 from "./MTag.vue?vue&type=style&index=0&id=b90bdeea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90bdeea",
  null
  
)

export default component.exports